import {
  buildCertificatesUrlRelative,
  buildDegreeUrlAbsolute,
  buildMastertrackUrlAbsolute,
} from 'bundles/common/utils/urlUtils';
import { LEARNING_PRODUCTS } from 'bundles/search-common/constants';

// Variants we support rendering on the partner page.
// ON_CAMPUS_PROGRAM and UNKNOWN are excluded.
const SUPPORTED_DEGREE_VARIANTS = new Set([
  'BACHELORS_DEGREE',
  'MASTERS_DEGREE',
  'POSTGRADUATE_DIPLOMA',
  'UNIVERSITY_CERTIFICATE',
  'MASTER_TRACK',
  'GRADUATE_CERTIFICATE',
  'PROFESSIONAL_CERTIFICATE_DEGREE',
]);

export function isSupportedDegreeVariant(productVariant: string): boolean {
  return SUPPORTED_DEGREE_VARIANTS.has(productVariant);
}

export function getDegreeUrl(productVariant: string, slug: string): string {
  if (productVariant === 'MASTER_TRACK') {
    return buildMastertrackUrlAbsolute(slug);
  }
  if (productVariant === 'UNIVERSITY_CERTIFICATE' || productVariant === 'GRADUATE_CERTIFICATE') {
    return buildCertificatesUrlRelative(slug);
  }
  return buildDegreeUrlAbsolute(slug);
}

export function getDegreeProductType(
  productVariant: string
): (typeof LEARNING_PRODUCTS)[keyof typeof LEARNING_PRODUCTS] {
  switch (productVariant) {
    case 'MASTER_TRACK':
      return LEARNING_PRODUCTS.Mastertrack;
    case 'UNIVERSITY_CERTIFICATE':
      return LEARNING_PRODUCTS.UniversityCertificate;
    case 'GRADUATE_CERTIFICATE':
      return LEARNING_PRODUCTS.GraduateCertificate;
    case 'POSTGRADUATE_DIPLOMA':
      return LEARNING_PRODUCTS.PostgraduateDiploma;
    case 'PROFESSIONAL_CERTIFICATE_DEGREE':
      return LEARNING_PRODUCTS.ProfessionalCertificate;
    default:
      return LEARNING_PRODUCTS.Degree;
  }
}
